import { atom } from "jotai";

import { zslAtom } from "./zslAtom";

export const hasZslAtom = atom<boolean>((get) => {
  const zsl = get(zslAtom);

  return Object.keys(zsl || {}).length > 0;
});

hasZslAtom.debugLabel = "hasZslAtom";
